<template lang="pug">
component(:is="'a'" v-bind="btnProps") 
  slot(name="default")
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: "#",
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    colorClass() {
      switch (this.variant) {
        case "white":
          return "bg-white ";
        case "accent":
          return "bg-pink-500 hover:bg-pink-400 text-white";
        case "primary":
        default:
          return "bg-blue-500 hover:bg-blue-600 text-white";
      }
    },
    btnProps() {
      const baseClass =
        "rounded-sm select-none cursor-pointer inline-flex items-center justify-center";
      const sizeClass = "px-6 py-2 text-md";
      return {
        class: `${baseClass} ${this.colorClass} ${sizeClass}`,
        href: this.href,
      };
    },
  },
};
</script>
